// extracted by mini-css-extract-plugin
export default {"navbar":"Header_navbar__LmReW","heading":"Header_heading__Ai2dB","menuButton":"Header_menuButton__EC8-e"};